const multipliersPerBucket = [1, 2, 3]
const bucketSizes = [5, 15, Infinity]

const referralBonusCalc = referral => {
  return bucketSizes
    .map(size => {
      const count = referral >= size ? size : referral
      referral = referral >= size ? referral - size : 0

      return count
    })
    .map((count, i) => count * multipliersPerBucket[i] || 0)
    .reduce((a, b) => a + b)
}

// disable for testing
export default referralBonusCalc

// enable for testing
// module.exports = referralBonusCalc
